import { useEffect, useState } from "react";
import { motion } from "framer-motion";

/**
 * Tracks mouse position and renders a soft gradient that follows the cursor.
 */
export default function MouseGradient() {
  const [pos, setPos] = useState({ x: 50, y: 50 });

  useEffect(() => {
    const onMove = (e) => {
      setPos({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100,
      });
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  return (
    <motion.div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-0"
      style={{
        background: `radial-gradient(600px circle at ${pos.x}% ${pos.y}%, rgba(59,130,246,0.10), transparent 40%)`,
      }}
    />
  );
}
